import React from 'react';

import { PencilSimpleIcon, PaletteIcon, PaintRollerIcon } from '@phosphor-icons/react';

import SlideImage from '@components/Presentation/main/Sidebar/SlideImage';

import { interactionsName } from '@services/utils.service';

const InteractionHeader = ({ featureType, selectedPanelBtn, setSelectedPanelBtn, isInstantCustomisationPopup = false }) => {
  return (
    <div className="w-full flex flex-col">
      {!isInstantCustomisationPopup && <div className="flex gap-2 items-center pb-4">
        <SlideImage slideType={featureType} color='#707070' />
        <div className="text-xl text-default-900">{interactionsName[featureType]?.name}</div>
      </div>}
      <div className="w-full flex items-center cursor-pointer">
        <h3
          className={`flex-1 text-sm font-semibold py-0.5 text-center ${selectedPanelBtn === 'Content' ? 'border-b border-primary-500 text-primary-500' : 'border-b border-grey-200 dark:border-grey-700 text-default-900'}`}
          onClick={() => setSelectedPanelBtn('Content')}
        >
          <div className="w-full flex items-center justify-center gap-2">
            <PencilSimpleIcon size={20} /><div>Content</div>
          </div>
        </h3>
        {isInstantCustomisationPopup && <h3
          className={`flex-1 text-sm font-semibold py-0.5 text-center ${selectedPanelBtn === 'Design' ? 'border-b border-primary-500 text-primary-500' : 'border-b border-grey-200 dark:border-grey-700 text-default-900'}`}
          onClick={() => setSelectedPanelBtn('Design')}
        >
          <div className="w-full flex items-center justify-center gap-2">
            <PaletteIcon size={20} /><div>Design</div>
          </div>
        </h3>}
        <h3
          className={`flex-1 text-sm font-semibold py-0.5 text-center ${selectedPanelBtn === 'Themes' ? 'border-b border-primary-500 text-primary-500' : 'border-b border-grey-200 dark:border-grey-700 text-default-900'}`}
          onClick={() => setSelectedPanelBtn('Themes')}
        >
          <div className="w-full flex items-center justify-center gap-2">
            <PaintRollerIcon size={20} /><div>Themes</div>
          </div>
        </h3>
      </div>
    </div>
  );
};

export default InteractionHeader;
